const loadMore = document.querySelectorAll('.load-more.intra-posts');
loadMore.forEach((button) => {
  button.addEventListener('click', () => {
    document.querySelector('.loading').classList.add('is-active');
    const buttonItem = button;
    axios
      .get(`${localData.siteURL}?action=getMoreIntraPosts&page=${buttonItem.dataset.page}&categories=${buttonItem.dataset.categories}&types=${buttonItem.dataset.types}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          buttonItem.closest('.intra-content__block').querySelector('.intra-content__news-list').innerHTML += response.data.data.html;
          buttonItem.dataset.page = response.data.data.page;
          if (!response.data.data.next) {
            buttonItem.style.display = 'none';
          }
        }
        document.querySelector('.loading').classList.remove('is-active');
      })
  });
});
const loadMoreProjects = document.querySelectorAll('.load-more.intra-projects');
loadMoreProjects.forEach((button) => {
  button.addEventListener('click', () => {
    document.querySelector('.loading').classList.add('is-active');
    const buttonItem = button;
    axios
      .get(`${localData.siteURL}?action=getMoreIntraProjects&page=${buttonItem.dataset.page}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          buttonItem.closest('.intra-content').querySelector('.intra-project-list__inner').innerHTML += response.data.data.html;
          buttonItem.dataset.page = response.data.data.page;
          if (!response.data.data.next) {
            buttonItem.style.display = 'none';
          }
        }
        document.querySelector('.loading').classList.remove('is-active');
      })
  });
});
window.addEventListener('load', () => {
  setTimeout(() => {
    const productList = document.querySelector('.project-container');
    if (productList) {
      // eslint-disable-next-line no-new
      new Sortable(productList, {
        handle: '.project-editor__arrange-btn',
        animation: 200,
        delay: 0,
        delayOnTouchOnly: true,
        ghostClass: "sortable-ghost",
        onEnd: (evt) => {
          const editor = evt.item.querySelector('textarea');
          tinymce.execCommand('mceRemoveEditor', false, editor.id)
          tinymce.execCommand('mceAddEditor', false, editor.id)
        },
      });
    }
    const addButtonProject = document.querySelector('a.project-editor__add-btn');
    if (addButtonProject) {
      addButtonProject.addEventListener('click', (ev) => {
        ev.preventDefault();
        const firstHiddenBox = document.querySelectorAll('.project-editor__item-inner.hidden');
        if (firstHiddenBox[0]) {
          firstHiddenBox[0].classList.remove('hidden');
          firstHiddenBox[0].querySelector('input.input-field__input').focus();
        }
        if (firstHiddenBox.length === 1) {
          addButtonProject.classList.add('hidden');
        }
      });
    }
    const removeButtonProject = document.querySelectorAll('button.project-editor__arrange-delete');
    if (removeButtonProject) {
      removeButtonProject.forEach((item, key) => {
        item.addEventListener('click', (ev) => {
          ev.preventDefault();
          const closestBox = ev.target.closest('.project-editor__item-inner');
          closestBox.classList.add('hidden');
          closestBox.querySelector('.input-field__input').value = '';
          tinyMCE.get(`section_editor_${key}`).setContent('');
          const firstHiddenBox = document.querySelectorAll('.project-editor__item-inner.hidden');
          if (firstHiddenBox) {
            addButtonProject.classList.remove('hidden');
          }
        });
      });
    }
    const saveButtonProject = document.querySelector('.submit-projects-intranet');
    if (saveButtonProject) {
      const hiddenValues = document.querySelectorAll('.hidden-tiny-mce');
      hiddenValues.forEach((item, i) => {
        tinyMCE.editors[i].setContent(`${item.value}`);
      });
      saveButtonProject.addEventListener('click', () => {
        document.querySelector('.loading').classList.add('is-active');
        const formDataInput = new FormData();
        formDataInput.append('id', localData.post_id);
        const editorText = document.querySelectorAll('.project-container textarea.tinymce-editor-input');
        editorText.forEach((item, i) => {
          formDataInput.append(`section_editor_${i}`, tinymce.get(item.id).getContent());
        });
        formDataInput.append('editor', tinyMCE.editors[0].getContent());
        const titleText = document.querySelectorAll('input.input-field__input');
        titleText.forEach((item, i) => {
          formDataInput.append(`title_text_${i}`, item.value);
        });
        axios
          .post(`${localData.siteURL}?action=saveUsersProjects`, formDataInput, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            if (response.status === 200) {
              window.location = response.data.data.url;
            }
            document.querySelector('.loading').classList.remove('is-active');
          })
      });
    }
  }, 500);
});
